import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_right",
  "use": "icon-ic_right-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_right\">\n<g id=\"icon-ic_right_ic_right\">\n<path id=\"icon-ic_right_Vector\" d=\"M9.08578 5.50002L1 5.50002V6.50002L9.08578 6.50002L5.69669 9.88908L6.40379 10.5962L10.6464 6.35358C10.8417 6.15832 10.8417 5.84173 10.6464 5.64647L6.40379 1.40381L5.69669 2.11091L9.08578 5.50002Z\" fill=\"#999999\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol